import { DIContainer } from "../../../../../../Global/Base/DIContainer";
import { DropDownMenuHorizontalOpen } from "../../../../../../UI/UI.Controls/DropDownMenu/DropDownInterfaces";
import { DropDownMenu } from "../../../../../../UI/UI.Controls/DropDownMenu/DropDownMenu";
import { registerCustomElement } from "../../../../../../UI/UI.ElementarControls/Utils/CustomElementUtils";
import { LocalizedStringBuilder } from "../../../../../../UI/UI/UI/DataBuilders/LocalizedStringBuilder";
import { MessageType, MessageWindow } from "../../../../../../UI/UI/UI/MessageWindow";
import { DropDownTextAreaItem } from "../DropDownMenuItems/DropDownTextAreaItem";
import { IExtendedFilterParser } from "../FilterInterfaces";
/** Popup rozšířeného filtru */
export class ExtendedFilterEdit extends DropDownMenu {
    //#region Fields
    public dataType: string;
    private _textArea: DropDownTextAreaItem;
    private _parser: IExtendedFilterParser;
    //#endregion Fields

    protected override _constructor(): void {
        super._constructor();

        this.horizontalOpenPosition = DropDownMenuHorizontalOpen.left;
        this.disableCloseTimeout = true;

        this._parser = DIContainer.instance.create(IExtendedFilterParser);

        this._parser.failed.add((_sender, invalidSubstring) => {
            const m = new MessageWindow(new LocalizedStringBuilder("GUI-687242", [invalidSubstring])); // Hodnota "@0" není validní pro tento typ sloupce
            m.type = MessageType.alert;
            m.stopClickPropagation = true;
            m.show();
        });
    }

    //#region Methods
    protected override _createElement(): void {
        super._createElement();

        this._textArea = new DropDownTextAreaItem();
        this.addItem(this._textArea);

        this.visible = true;
    }

    protected override connectedCallback(): void {
        super.connectedCallback();

        this._textArea.registerEventListener("ConfirmInput", () => this._parseInput(this._textArea));
    }

    /** Zpracuje vstup a vrátí nově vytvořené operace filtru */
    protected _parseInput(textarea: DropDownTextAreaItem): void {
        const result = this._parser.parse(textarea.text, this.dataType);

        if (!result || result.length === 0) {
            return;
        }

        this.callEvent("ExtendedFilterParsed", {
            filters: result,
            element: this,
        }, true);

        this.close();
    }

    /**
     * Zavře aktuální a všechny podřízené nabídky
     */
    public override close(_dontOpenOnNextClick: boolean = false): void {
        super.close();
        this.onClose.trigger(this, null);
    }
    //#endregion Methods
}

registerCustomElement("tsc-ExtendedFilterEdit", ExtendedFilterEdit);
